import {styled} from "@mui/material";

export const CourseComponentWrapper = styled('div')({
  minHeight: '300px',
});
